import { IconStyled, IconStylesProps } from './IconStyles';

export const ArrowUp = ({
  size = 'base',
  className = '',
  fill = 'currentColor',
}: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox='0 0 9 6'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.90203 0.198405L8.66945 4.0246C8.92984 4.28906 8.92984 4.71669 8.66945 4.97833L8.04339 5.61416C7.783 5.87861 7.36193 5.87861 7.10431 5.61416L4.43388 2.90206L1.76344 5.61416C1.50305 5.87861 1.08198 5.87861 0.824359 5.61416L0.198303 4.97833C-0.0620917 4.71388 -0.0620917 4.28624 0.198303 4.0246L3.96572 0.198405C4.22057 -0.0660528 4.64164 -0.0660528 4.90203 0.198405Z'
      fill={fill}
    />
  </IconStyled>
);
